import styled, { css } from 'styled-components';

export const StyledConnectAccountSteps = styled.div`
  min-height: 500px;
  position: relative;
  padding: 20px 25px 80px;

  ${({ ContentCenter }) =>
    ContentCenter &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  ${({ hasIframe }) =>
    hasIframe &&
    css`
      padding: 0;
      margin: 0;
      overflow: hidden;
    `}

  .heading {
    display: block;
    font-size: 25px;
    line-height: 29px;
    color: var(--black);
    margin: 0 0 16px;

    &.first-step {
      margin: 0 0 5px;
    }
  }

  .sub-heading {
    display: block;
    margin: 0 0 25px;
  }

  .input-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }

  .proxy-holder {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    margin: 0 0 20px;

    .radio {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      border-radius: 50px;
      border: 2px solid var(--blue);
      cursor: pointer;
      position: relative;

      &.active {
        &::before {
          visibility: visible;
          opacity: 1;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 2px;
        right: 2px;
        width: 12px;
        height: 12px;
        background: var(--blue);
        border-radius: 50px;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s;
      }
    }

    .content-holder {
      width: 100%;
      .label-holder {
        cursor: pointer;
      }
      .label {
        display: block;
        font-size: 18px;
        line-height: 22px;
        color: var(--black);
        margin: 0 0 10px;
      }

      .text {
        display: block;
        margin: 0 0 20px;
      }

      .form-hook-country-field {
        padding-left: 50px;
        max-width: 450px;
        height: 0;
        overflow: hidden;
        transition: 0.3s;

        &.active {
          height: 73px;
        }

        .react-select__control {
          border-radius: 10px;
          margin: 0;
        }
      }

      .own-proxy {
        width: 100%;
        max-width: 600px;
        height: 0;
        overflow: hidden;
        transition: 0.3s;

        &.active {
          height: 320px;
        }

        .input-holder {
          display: flex;
          gap: 16px;
        }
      }
    }
  }

  .verify-proxy,
  .verified {
    text-align: center;

    img {
      margin: 0 0 20px;
    }

    .heading {
      display: block;
      font-size: 24px;
      line-height: 28px;
      font-weight: 500;
      margin: 0 0 10px;
    }
    .text {
      font-size: 16px;
      line-height: 20px;
    }
  }

  .connection-step {
    text-align: center;
    .icon {
      margin: 0 0 20px;
    }
    .heading {
      font-weight: 500;
      margin: 0 0 25px;
    }
  }

  .verify-step {
    .img-wrapper {
      width: max-content;
      position: relative;
      margin: 0 auto 15px;

      .img-holder {
        width: 85px;
        height: 85px;
        border-radius: 50px;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .icon-holder {
        position: absolute;
        bottom: 0;
        left: -5px;
        width: 25px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #0076b9;
        border: 2px solid var(--white);
        border-radius: 50px;
        overflow: hidden;
      }
    }

    .user-name {
      display: block;
      font-size: 18px;
      line-height: 22px;
      font-weight: 500;
      color: var(--black);
      text-align: center;
      margin: 0 0 10px;
    }

    .designation {
      display: block;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      margin: 0 0 10px;
    }

    .tag {
      font-weight: 500;
      color: var(--blue);
      background: var(--primary-100);
      padding: 5px 20px 5px 35px;
      border-radius: 50px;
      text-align: center;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
        background: var(--blue);
        border-radius: 20px;
      }
    }
  }

  .btn-holder {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-top: 1px solid #e6e7ec;
    background: var(--white);

    &::before {
      display: none;
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      height: 30px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #f4f4f4 100%);
    }

    .btn-wrap,.btn-wrap-two {
      display: flex;
      gap: 10px;
      width: 100%;
      max-width: 300px;
    }
    
    .btn-wrap-two{
      max-width: 155px;
      &.error-btn {
        max-width: 300px;
      }
    }
 
  }

  iframe {
    width: 100%;
    height: calc(100vh - 110px);
    display: block;
    border: none;
    margin: 0;
    padding: 0;
  }
`;
